var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tag_svg__clip0_134_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0h-12c-.825 0-1.977.477-2.561 1.061L1.06 15.94a1.505 1.505 0 000 2.121L13.939 30.94a1.505 1.505 0 002.121 0l14.879-14.879C31.522 15.478 32 14.325 32 13.5v-12c0-.825-.675-1.5-1.5-1.5zM23 12a3 3 0 110-6 3 3 0 010 6z",
    fill: props.color || 'black'
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tag_svg__clip0_134_196"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgTag;